<template>
  <div class="culture">
      <article>
        <h4>企业方向</h4>
        <ul>
          <li>企业使命：为客户提供有竞争力的仓库存储解决方案和服务，持续为客户创造最大价值。</li>
          <li>企业愿景：为客户创造价值；辛辛苦苦工作，踏踏实实赚钱。</li>
          <li>企业目标：成为中国仓储设备行业最具影响力的领航企业一</li>
          <li>企业价值观：正直、进去、务实、合作、创新</li>
        </ul>  
      </article>
      <br>
      <article>
        <h4>经营理念</h4>
        <ul>
          <li>经营理念：诚信、专业、分享、共赢、发展</li>
          <li>行为理念：安全、责任、专心、高效、感恩</li>
          <li>产 品 观：以质兴业、以优取胜</li>
          <li>人才理念：同心、同德、同向、同发展</li>
        </ul>  
      </article>
      
  </div>
</template>

<script>
export default {
  name: 'Culture',
  data () {
    return {
      
    }
  },
  methods:{
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
  text-align: left;
  text-indent: 6px;
  font-family: 微软雅黑;
  letter-spacing: 1px;
  color: #2D2D2D;
  font-size: 13px;
  line-height: 26px;
}
h4{
  font-size: 16px;
  font-weight: border;
  color: black;
}
ul li{
  list-style-type: none;
}
.culture{
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Introduce/culture.vue